module.exports = __webpack_public_path__ + "img/renegades-le_mclarenplus.c8a03db.png";